import { useEffect } from 'react';
import { useDebugStore } from '@/store/useDebugStore';
import { useNavigationStore } from '@/store/useNavigationStore';

/**
 * Minimal HTML overlay on top of the canvas: brand watermark in the
 * corner, plus a contextual "Geri Dön" button that appears once the
 * user has arrived at a page. Esc also returns home.
 */
export function Hud() {
  const show = useDebugStore((s) => s.showHud);
  const phase = useNavigationStore((s) => s.phase);
  const returnHome = useNavigationStore((s) => s.returnHome);

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') returnHome();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [returnHome]);

  if (!show) return null;

  return (
    <>
      <div className="brand-watermark">
        <span className="brand-watermark__name">Pinorion</span>
        <span className="brand-watermark__tag">Kurumsal IT</span>
      </div>

      {(phase === 'arrived' || phase === 'warping') && (
        <button
          type="button"
          className="btn btn--ghost btn--lg back-btn"
          onClick={returnHome}
        >
          ← Geri Dön
        </button>
      )}
    </>
  );
}
